import { render } from "./BadRequest.vue?vue&type=template&id=72ba2755"
const script = {}

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__